import { getRichTextExtensions } from '~/lib/tiptap/extensions/rich-text'
import { clsx } from 'clsx'
import { PrimitiveTipTapEditor } from '~/lib/tiptap/components/primitive-editor'
import { useCollaborationData } from '~/hooks-data/use-repo-presence'

import { type RichTextBlock } from '@basehub/data/replicache/index'
import type { BlocksProps } from '..'
import './rt-editor.scss'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
import { getAllowedFormatting } from './_utils'

export const RichTextPreviewBlock = ({
  block,
  _key,
  ...props
}: {
  block: RichTextBlock
  _key: string
  path: string
  parent: BlocksProps['block']
} & {
  className?: string
}) => {
  const optimisticUser = useCollaborationData()

  return (
    <PrimitiveTipTapEditor
      user={optimisticUser}
      clientId={undefined}
      instanceId={`preview-${idToSourceBlockId(block)}`}
      getExtensions={({ ...collab }) => {
        return getRichTextExtensions({
          collaborationExtensionsOptions: collab,
          linterExtensionOptions: {
            allowedFormatting: getAllowedFormatting(block.constraints),
          },
          onClickBshbInstanceNode: () => {},
          slashCommand: {
            component: [] as any,
            onSelectBlock: () => {},
            richTextId: block.id,
          },
        })
      }}
      key={_key}
      onUpdate={() => {}}
      value={block.value.state}
      readOnly
      className={clsx('rt-editor')}
      {...props}
    />
  )
}
